// Created by jarongallo at 3/31/21
import React, { useEffect, useState } from 'react';
import UISearchBar, { UI_SEARCH_BAR_TYPES } from '../../../../../components/UI/UISearchBar';
import PLTable from '../../../../../components/PL/PLTable/PLTable';
import { LISTINGS_TABLE_TYPE } from '../../../../../components/PL/PLTable/config';
import { useLazyQuery } from '@apollo/react-hooks';
import { GET_TECHNICIAN_LISTINGS } from './queries';
import * as strings from './strings';
import { useHistory, useLocation } from 'react-router-dom';
import { getPaginatedTableVariablesByTypeAndSearchTypeScript } from '../../../../../components/PL/PLTable/TypeScriptHelpers';
import { QUERY_LIMIT } from '../../../roles/Admin/AdminRegions/config';
import { useSelector } from 'react-redux';
import { getFiltersProp } from '../../../../../redux/selectors/CurrentUserSelectors';

export default function IndividualTechnicianListings({ technicianId }: IndividualTechnicianListingsProps) {
	const history = useHistory();

	const [listings, setListings] = useState<ListingType[]>();

	let baseVariables = { query: { clientId: { op_eq: technicianId } } };

	const filters = useSelector(getFiltersProp);
	const location = useLocation();
	let props = {
		filters,
		location
	};

	let variables = getPaginatedTableVariablesByTypeAndSearchTypeScript(QUERY_LIMIT, LISTINGS_TABLE_TYPE, props, baseVariables);
	const [getListings, { data: listingsData }] = useLazyQuery(GET_TECHNICIAN_LISTINGS, {
		variables
	});

	useEffect(() => {
		(async () => {
			await getListings();
		})();
	}, []);

	useEffect(() => {
		(() => {
			if (listingsData) {
				const fetchedListings: ListingType[] = listingsData['listings'];
				if (fetchedListings) {
					setListings(fetchedListings);
				}
			}
		})();
	}, [listingsData]);

	if (!listings) return null;

	return (
		<div className='individualTechnician__content-tables'>
			<div className='general-header-pin'>
				<UISearchBar type={UI_SEARCH_BAR_TYPES.listing} onSearchUpdated={getListings} placeholder={'search...'} />
			</div>
			<PLTable
				emptySetText={strings.emptySetText}
				type={LISTINGS_TABLE_TYPE}
				limit={20}
				updateTable={getListings}
				data={listings}
				onSelect={(listing) => history.push(`/listing/${listing.id}`)}
			/>
		</div>
	);
}
